/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table,
} from 'antd';
import dayjs from 'dayjs';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import MOActions from '@Actions/moActions';
import {
  INFINITE_EXPIRY_DATE, QUANTITY,
} from '@Apis/constants';

/**
 * @param withApproval
 */
class BatchSelector extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);
    this.state = {
      batchColumns: [{
        title: '',
        render: (record) => {
          const { expiryDays, uomInfo } = this.props;
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          const shelfLifePct = Math.round(((shelfLife / expiryDays) * 100)) > 100 ? 100 : Math.round(((shelfLife / expiryDays) * 100));
          return (
            <div className="mobile-list__item">
              <H3Text text={`Batch# ${record?.custom_batch_number || record?.batch_number}`} className="mobile-list__item-number" />
              {record?.lot_number && <H3Text text={`Lot# - ${record?.lot_number}`} className="mobile-list__item-info" />}
              {expiryDays >= 0 ? (
                <H3Text
                  text={`Shelf Life# - ${shelfLifePct}% (${shelfLife} Days)`}
                  className="mobile-list__item-info"
                />
              ) : ''}
              {record?.cost_price ? <H3Text text={`Cost Price# - ${record?.cost_price}`} className="mobile-list__item-info" /> : ''}
              <H3Text text={`Quantity - ${QUANTITY(Math.abs(record?.quantity), uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`} className="mobile-list__item-info" />
            </div>
          );
        },
        responsive: ['xs'],
      },
      {
        title: 'Batch#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => record?.custom_batch_number || record?.batch_number,
        width: '120px',
        fixed: 'left',
      },
      {
        title: 'Lot#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => record?.lot_number || '-',
      },
      {
        title: 'Expiry',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        width: '80px',
        render: (text, record) => (dayjs(record.expiry_date).format('YYYY-MM-DD') !== INFINITE_EXPIRY_DATE ? dayjs(record?.expiry_date).format('DD MMM, YY') : '-'),
      },
      {
        title: 'Shelf Life',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => {
          const { expiryDays } = this.props;
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          let shelfLifePct = Math.round(((shelfLife / expiryDays) * 100)) > 100 ? 100 : Math.round(((shelfLife / expiryDays) * 100));

          if (dayjs(record.expiry_date).format('YYYY-MM-DD') === INFINITE_EXPIRY_DATE) shelfLifePct = 100;
          if (expiryDays < 0) {
            return (
              <div style={{ width: '220px' }}>
                No Expiry (100%)
              </div>
            );
          }
          return (
            (
              <div className="batch-shelf-life">
                {dayjs(record.expiry_date).format('YYYY-MM-DD') !== INFINITE_EXPIRY_DATE && expiryDays !== -1 && (
                  <div
                    className="progress-line__wrapper"
                    style={{
                      width: '80px',
                      backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                    }}
                  >
                    <div
                      className="progress-line"
                      style={{
                        width: `${shelfLifePct}%`,
                        backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                      }}
                    />
                  </div>
                )}
                <span>
                  {(dayjs(record.expiry_date).format('YYYY-MM-DD') === INFINITE_EXPIRY_DATE || expiryDays === -1) ? 'No Expiry (100%)' : `${shelfLife} Days (${shelfLifePct}%)`}
                </span>
              </div>
            )
          );
        },
      },
      {
        title: 'CP',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (record?.cost_price ? this.props.MONEY(record?.cost_price) : '-'),
      },
      {
        title: 'MRP',
        render: (text, record) => (record?.mrp ? this.props.MONEY(record?.mrp) : '-'),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Quality',
        render: (text, record) => (
          <div className="qr__status" style={{ backgroundColor: record?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
            {record?.is_rejected_batch ? 'Bad' : 'Good'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Quantity',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => {
          const { uomInfo } = this.props;
          return (
            <div>{`${QUANTITY(Math.abs(record?.quantity), uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
          );
        },
        fixed: 'right',
      },
      ],
    };
  }

  /**
   *
   * @param {*} oldBaches
   * @param {*} quantity
   * @return
   */
  getBatches(oldBaches, quantity) {
    const batches = oldBaches;
    let remainingQty = quantity;
    for (let i = 0; i < batches?.length; i++) {
      batches[i].consumed_qty = 0;
    }
    for (let i = 0; i < batches?.length; i++) {
      if (remainingQty > 0 && Number(batches[i].consumed_qty || '0') < batches?.[i]?.available_qty) {
        batches[i].consumed_qty = batches?.[i]?.available_qty > remainingQty ? remainingQty : batches?.[i]?.available_qty;
        remainingQty -= batches[i].consumed_qty;
      } else {
        batches[i].consumed_qty = 0;
        remainingQty -= batches[i].consumed_qty;
      }
    }
    return batches;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      batches, title, updateMOAdjustmentStatusLoading,
    } = this.props;
    const { batchColumns } = this.state;
    return (
      <div className="batch-selector-wrapper">
        <H3Text text={title} className="batch-selector-title" />
        <Table
          size="small"
          columns={batchColumns}
          dataSource={batches}
          pagination={false}
          loading={updateMOAdjustmentStatusLoading}
          bordered
          scroll={{ x: 'max-content' }}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers, MOReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateMOAdjustmentStatusLoading: MOReducers.updateMOAdjustmentStatusLoading,

});

const mapDispatchToProps = (dispatch) => ({
  updateMOAdjustmentStatus: (payload, callback) => dispatch(MOActions.updateMOAdjustmentStatus(payload, callback)),
  getMOById: (tenantId, moId) => dispatch(MOActions.getMOById(tenantId, moId)),
});
BatchSelector.propTypes = {
  expiryDays: PropTypes.any,
  batches: PropTypes.any,
  uomInfo: PropTypes.any,
  title: PropTypes.any,
  isFinishedGood: PropTypes.bool,
  row: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BatchSelector));
